import BrandLovers from '@assets/img/svg/solution/brandlovers.svg'
import Opportunity from '@assets/img/svg/solution/opportunity.svg'
import Performance from '@assets/img/svg/solution/performace.svg'
import Research from '@assets/img/svg/solution/research.svg'
import CampaignModalFilter from '@components/campaign-modal-filter/campaign-modal-filter.component'
import SocialNetworkFilter from '@components/social-network-filter/social-network-filter.component'
import { withTransaction } from '@elastic/apm-rum-react'
import { Campaign, CampaignQuantityBySocialNetwork, HubCampaignsService, Loader, LogService, UserInCampaign } from '@hub/shared'
import BackToTop from '@src/components/back-to-top/back-to-top.component'
import ModalIncompleteProfileComponent from '@src/components/modal-incomplete-profile/modal-incomplete-profile.component'
import CampaignType from '@src/enums/campaign-type.enum'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SectionCampaigns from './components/section-campaigns/section-campaigns.component'
import './home-campaign.page.scss'
import { SqLoader } from '@squidit/react-css'
interface ObjectCampaign {
  campaign: Campaign
  additionalInformation: UserInCampaign
}
export interface SectionCampaignInterface {
  img?: string
  value: string
  icon?: any
  show: boolean
  route: string
  smallCard: boolean
  bottomLine: boolean
  badge?: boolean
  loading: boolean
}
const HomeCampaignPageComponent = (props: any) => {
  const [t] = useTranslation('homeCampaign')
  const logService = useMemo(() => new LogService(), [])
  const hubCampaignsService = useMemo(() => new HubCampaignsService(), [])
  const [loading, setLoading] = useState(true)
  const [campaignQuantity, setCampaignQuantity] = useState<CampaignQuantityBySocialNetwork | null>(null)
  const [loadingQuantity, setLoadingQuantity] = useState<boolean>(false)
  const [campaigns, setCampaigns] = useState<{
    invited: Array<ObjectCampaign>
    opportunity: Array<ObjectCampaign>
    brandLovers: Array<ObjectCampaign>
    performance: Array<ObjectCampaign>
    researches: Array<ObjectCampaign>
    sent: Array<ObjectCampaign>
    participating: Array<ObjectCampaign>
    finished: Array<ObjectCampaign>
  }>({
    invited: [],
    opportunity: [],
    brandLovers: [],
    performance: [],
    researches: [],
    sent: [],
    participating: [],
    finished: [],
  })
  const [filterState, setFilterState] = useState({
    socialNetworkFilter: 'all',
  })
  const [socialNetworkFilter, setSocialNetworkFilter] = useState<'instagram' | 'twitter' | 'youtube' | 'tiktok' | ''>('')
  const [loadingList, setLoadingList] = useState<boolean>(false)
  const [listTypes, setListTypes] = useState<SectionCampaignInterface[]>([
    {
      value: 'invited',
      icon: '',
      show: false,
      route: 'campaigns/invited',
      smallCard: false,
      bottomLine: true,
      badge: true,
      loading: true,
    },
    {
      img: Opportunity,
      value: 'opportunity',
      show: true,
      route: 'campaigns/opportunity',
      icon: 'fa-solid fa-party-horn',
      smallCard: false,
      bottomLine: true,
      loading: true,
    },
    {
      img: BrandLovers,
      value: 'brandLovers',
      show: false,
      icon: 'fa-solid fa-heart',
      route: 'campaigns/brandLovers',
      smallCard: false,
      bottomLine: true,
      loading: true,
    },
    {
      img: Performance,
      value: 'performance',
      show: false,
      icon: 'fa-solid fa-chart-column',
      route: 'campaigns/performance',
      smallCard: false,
      bottomLine: true,
      loading: true,
    },
    {
      img: Research,
      value: 'researches',
      show: false,
      route: 'campaigns/researches',
      smallCard: false,
      icon: 'fa-solid fa-file-magnifying-glass',
      bottomLine: true,
      loading: true,
    },
    {
      value: 'participating',
      icon: 'fa-solid fa-camera',
      show: true,
      route: 'campaigns/participating',
      smallCard: true,
      bottomLine: false,
      loading: true,
    },
    {
      value: 'sent',
      icon: 'fa-solid fa-bars-progress',
      show: true,
      route: 'campaigns/sent',
      smallCard: true,
      bottomLine: false,
      loading: true,
    },
    {
      value: 'finished',
      icon: 'fa-solid fa-flag-checkered',
      show: true,
      route: 'campaigns/finished',
      smallCard: true,
      bottomLine: false,
      loading: true,
    },
  ])
  logService.init('Campaings Home Page')
  const fetchCampaigns = useCallback(
    async (socialNetwork: 'instagram' | 'twitter' | 'youtube' | 'tiktok' | '', type: string) => {
      setLoadingList(true)
      setListTypes((prevState) => {
        const newState = prevState.map((obj) => {
          if (obj?.value === type) {
            return { ...obj, loading: true }
          }
          return obj
        })
        return newState
      })
      hubCampaignsService
        .getListCampaignsByType(CampaignType[type], socialNetwork, 1, 6)
        .then((e: any) => {
          setCampaigns((prev) => ({ ...prev, [type]: e?.data || [] }))
          if (['invited', 'brandLovers', 'performance', 'researches'].includes(type)) {
            setListTypes((prevState) => {
              const isShow = e?.data?.length > 0
              const newState = prevState.map((obj) => {
                if (obj?.value === type) {
                  return { ...obj, show: isShow }
                }
                return obj
              })
              return newState
            })
          }
        })
        .catch((err) => {
          logService.error({ message: err?.message, error: err })
        })
        .finally(() => {
          setListTypes((prevState) => {
            const newState = prevState.map((obj) => {
              if (obj?.value === type) {
                return { ...obj, loading: false }
              }
              return obj
            })
            return newState
          })
          setLoading(false)
          setLoadingList(false)
        })
    },
    [hubCampaignsService, logService]
  )
  const handleChange = useCallback(
    (socialNetwork: 'instagram' | 'twitter' | 'youtube' | 'tiktok' | ''): void => {
      listTypes?.forEach((item) => {
        fetchCampaigns(socialNetwork, item?.value)
      })
    },
    [listTypes, fetchCampaigns]
  )
  const handleShowList = (value: { any: boolean }) => {
    const values: [string, boolean] = Object.entries(value)[0]
    setListTypes((prevState) => {
      const newState = prevState.map((obj) => {
        if (obj?.value === values[0]) {
          return { ...obj, show: values[1] }
        }
        return obj
      })
      return newState
    })
  }
  const getCampaignQuantity = useCallback(async () => {
    if (!campaignQuantity && !loadingQuantity) {
      try {
        setLoadingQuantity(true)
        const response = await hubCampaignsService.getCampaignQuantity()
        setCampaignQuantity(response)
        setLoadingQuantity(false)
      } catch (error) {
        setLoadingQuantity(false)
      }
    }
  }, [campaignQuantity, loadingQuantity, hubCampaignsService, setCampaignQuantity])
  useEffect(() => {
    getCampaignQuantity()
    if (filterState.socialNetworkFilter !== socialNetworkFilter) {
      setFilterState({ ...filterState, socialNetworkFilter: socialNetworkFilter })
      handleChange(socialNetworkFilter)
    }
  }, [filterState, socialNetworkFilter, handleChange, getCampaignQuantity])
  if (loading) {
    return (
      <div className="text-center my-5" style={{ width: '100%' }}>
        <SqLoader size="big" />
      </div>
    )
  }
  return (
    <div>
      <main className="home-campaigns-page box mb-0">
        <header className="header-home-campaigns">
          <div className="mb-4">
            <h4>
              {t('pageTitle')}
              <CampaignModalFilter filterOptions={listTypes} onChange={(value) => handleShowList(value)}></CampaignModalFilter>
            </h4>
            <hr />
          </div>
          <div>
            <SocialNetworkFilter onChange={(value) => setSocialNetworkFilter(value)} quantity={campaignQuantity} loading={loadingList} />
          </div>
        </header>
        <div className="content-page">
          {listTypes?.map((itemType, index) =>
            itemType?.show ? (
              <SectionCampaigns
                type={itemType?.value}
                route={itemType?.route}
                img={itemType?.img}
                icon={itemType?.icon}
                key={`${itemType?.value}-${index}`}
                campaignList={campaigns[itemType?.value]}
                loading={itemType?.loading}
                smallCard={itemType?.smallCard}
                bottomLine={itemType?.bottomLine}
                badge={itemType?.badge}
              />
            ) : null
          )}
          <BackToTop />
        </div>
        <ModalIncompleteProfileComponent />
      </main>
    </div>
  )
}
export default withTransaction('HomeCampaignPageComponent', 'component')(HomeCampaignPageComponent)
